import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const API_BASE = process.env.REACT_APP_API_URL || "";

function StatsModal({ isOpen, onClose }) {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !token) return;

    let cancelled = false;
    setLoading(true);

    async function fetchStats() {
      try {
        const res = await fetch(`${API_BASE}/api/submissions/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to load stats");
        const data = await res.json();
        if (!cancelled) setStats(data);
      } catch {
        if (!cancelled) setStats(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchStats();
    return () => { cancelled = true; };
  }, [isOpen, token]);

  if (!isOpen) return null;

  return (
    <div
      className="modal"
      style={{ display: "block" }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-content">
        <span className="close" onClick={onClose} aria-label="Close">
          &times;
        </span>
        <h2>Statistics</h2>

        {loading && <p style={{ textAlign: "center" }}>Loading stats...</p>}

        {!loading && stats && (
          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-value">{stats.gamesPlayed}</span>
              <span className="stat-label">Played</span>
            </div>
            <div className="stat-box">
              <span className="stat-value">{stats.winPct}</span>
              <span className="stat-label">Win %</span>
            </div>
            <div className="stat-box">
              <span className="stat-value">{stats.currentStreak}</span>
              <span className="stat-label">Current Streak</span>
            </div>
            <div className="stat-box">
              <span className="stat-value">{stats.maxStreak}</span>
              <span className="stat-label">Max Streak</span>
            </div>
          </div>
        )}

        {!loading && !stats && (
          <p style={{ textAlign: "center", color: "rgba(226,232,240,0.5)" }}>
            Unable to load statistics.
          </p>
        )}
      </div>
    </div>
  );
}

export default StatsModal;
